import { Inventory } from "~/components/staff/inventory";

export const InventoryScreen = () => {
  return <Inventory />;
};
